import Vue from "vue";
import VueLocalStorage from "vue-localstorage";
Vue.use(VueLocalStorage);
